import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Select, Form, Button, Input, Upload, message, Icon, Card, Typography, Breadcrumb, DatePicker, Divider, Table, Calendar } from 'antd';
import { getStaticProRealInfo, getStaticReaInfoByMonth, getStaticRealListByMonth, getStaticReaList, getStaticReaInfo } from '@/api/api';
import moment from 'moment';
import echarts from 'echarts';
import utils from '@/api/util';
import './statistical.css';
import servers from '@/api/server'

const { RangePicker } = DatePicker;
const { Text, Title } = Typography;
let cost_cavans;



class Statistic_consume extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            reaList: [],
            reaIds: [],
            dataSource: [],
            table_loading: false,
            contextPage: 1,
            contextRows: 5,
            costYear: '',
            pagination: {
                pageSize: 5,
                hideOnSinglePage: true,
            },
            costMothRange: [],
            timeType: 3,
            storeRangeValue: [],
            storeRangeFormat: 'YYYY-mm',
            storeRangeMode: ['month', 'month'],
            storeRangeValue1: null,
            storeRangeValue2: null,
            storeInfo: {},
            costEcharts_flag: true,
            storeRangeOpen: false
        };
        this.getReaList = this.getReaList.bind(this);
        this.getReaCost = this.getReaCost.bind(this);
        this.realRealCostCanvas = this.realRealCostCanvas.bind(this);
        this.costRangeChange = this.costRangeChange.bind(this)
    }

    componentDidMount() {
        cost_cavans = echarts.init(document.getElementById('realCost'));
        cost_cavans.showLoading();
        this.getReaList()
        this.getReaCost({ type: 2 });
    }

    // 耗材list
    getReaList() {
        const that = this;
        getStaticReaList({}, res => {
            console.log(res);
            if (res.statusCode !== 1000) {
                return
            };
            that.setState({
                reaList: res.reaList
            });
        }, err => {
            console.log(err)
        })
    }

    // 获取耗材成本数据
    getReaCost(params) {
        const that = this;
        cost_cavans.showLoading()
        getStaticProRealInfo(params, res => {
            console.log(res);
            if (res.statusCode !== 1000) {
                return
            };
            that.setState({
                costEcharts_flag: res.per && res.per.length > 0
            })
            that.realRealCostCanvas(res)
        }, err => {
            console.log(err)
        })
    }

    // 耗材成本时间范围变化
    costRangeChange(date, dateString) {
        console.log(dateString);
        this.getReaCost({
            type: 2,
            beginTime: dateString[0],
            endTime: dateString[1]
        });
    }

    // 获取耗材成本绘制
    realRealCostCanvas(values) {
        const that = this;
        cost_cavans.clear();
        console.log(values)
        let datas = [];
        values.reaName.map((x, index) => {
            let ret = {};
            ret.value = (values.per[index] * 100).toFixed(1);
            ret.name = x;
            datas.push(ret)
        });
        cost_cavans.setOption({
            title: {
                text: '耗材成本占比',
                subtext: '耗材成本=耗材领用金额+损耗金额',
                x: 'center'
            },
            tooltip: {
                trigger: 'item',
                formatter: (params) => {
                    return params.seriesName + '<br/>' + params.name + ':' + params.value + '%(￥' + values.money[params.dataIndex] + ')'
                }
            },
            legend: {
                // orient: 'vertical',
                right: 'center',
                bottom: 20,
                data: values.reaName,
                formatter: function (name) {
                    if (name.length > 10) {
                        return name.substr(0, 15) + '..'
                    }
                    return name;
                }
            },
            series: [
                {
                    name: '耗材成本占比',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '50%'],
                    data: datas,
                    label: {
                        formatter: (params) => {
                            if (params.name.length > 16) {
                                return params.name.substr(0, 15) + '..'
                            };
                            return params.name;
                        }
                    },
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        });
        cost_cavans.on('rendered', function () {
            cost_cavans.hideLoading()
        });
    }
    // 耗材备用库存占比情况开始周选择
    storeDisabledStartWeek = (startValue) => {
        const endValue = this.state.storeRangeValue2;
        if (!startValue || !endValue) {
            return false;
        };
        let weekEnd = utils.getWeekRange(endValue.format("YYYY-MM-DD"))[0];
        return startValue.valueOf() > moment(weekEnd).valueOf();
    }

    // 耗材备用库存占比情况结束周选择
    storeDisabledEndWeek = (endValue) => {
        const startValue = this.state.storeRangeValue1;
        if (!endValue || !startValue) {
            return false;
        };
        let weekStart = utils.getWeekRange(startValue.format("YYYY-MM-DD"))[1];
        return endValue.valueOf() <= moment(weekStart).valueOf();
    }
    render() {
        const that = this;
        const { costEcharts_flag } = this.state;
        return (
            <div className="statistic">
                <Card
                    title={
                        <div className="pr">
                            <Text strong className="mr5" style={{fontSize:'15px'}}><i className="iconfont icon-icon--tongji c_8bff mr5 vm"></i>耗材成本占比</Text>
                            <RangePicker
                                format="YYYY-MM-DD"
                                showTime={false}
                                style={{ width: '240px' }}
                                onChange={this.costRangeChange}
                                className="pa_rm" />
                        </div>
                    }
                    className="statistic_panel"
                >
                    <div className="pr">
                        {!costEcharts_flag &&
                            <img src={servers.defaultNoContentPath} alt="暂无内容" className="noContent" />
                        }
                        <div className="statistic_pro_tabPane" id="realCost"></div>
                    </div>
                </Card >

            </div>
        )
    }
}


export default Statistic_consume;

